import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { useSetBulkIssuesList } from '../providers/BulkCreateContextProvider';
import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider';
import { useAiBulkNavigationGotoPage } from '../providers/AiBulkNavigationContextProvider';

import { mapActionItemsToIssues } from './actionItemUtils';

export const useMapActionItemsToIssues = () => {
	const [{ selectedActionItems }] = useIssueCreateSidePanelContext();
	const setBulkIssuesList = useSetBulkIssuesList();
	const goToPage = useAiBulkNavigationGotoPage();
	useEffect(() => {
		if (selectedActionItems && fg('confluence-create-work-items-from-action-items')) {
			const mappedIssues = mapActionItemsToIssues(selectedActionItems);
			void setBulkIssuesList(mappedIssues);
			if (mappedIssues.length === 0) {
				void goToPage('configure');
			}
		}
	}, [goToPage, setBulkIssuesList, selectedActionItems]);
};
